// PieChart.jsx
import React, { useState } from "react";
import Plot from "react-plotly.js";
import PropTypes from "prop-types";

const CurrentPiechart = ({
  labels,
  values,
  title,
  colors,
  kpis = [],
  type = "GAUGE",
  gaugeValue,
  gaugeColor,
  gaugeThreshhold = null,
  isEmptyState=false
}) => {
  // Validate props
  // if (!labels || !values || labels.length !== values.length) {
  //   console.error(
  //     "Labels and values must be provided and must be of the same length."
  //   );
  //   return null;
  // }

  const [annotations, setAnnotations] = useState([]);

  console.log('labels: ', labels)
  // Define data for the pie chart
  const data = [
    {
      type: "pie",
      labels: labels,
      values: values,
      textinfo: "label+percent",
      insidetextorientation: "radial",
      marker: {
        colors: colors || undefined, // Optional custom colors
        line: {
          color: 'black', // Set the border color
          width: 1 // Set the border width
        }
      },
      textposition: "inside",
    },
  ];

  // Define layout for the pie chart
  const layout = {
    title: title || "Pie Chart",
    autosize: true,
    showlegend: false,
    legend: {
      orientation: "h",
      x: 0.5,
      xanchor: "center",
      y: -0.2,
    },
    annotations: annotations,
  };

  const handleClick = (event) => {
    const sliceIndex = event.points[0].pointIndex; // Get the index of the clicked slice
    const sliceLabel = labels[sliceIndex]; // Get the corresponding label
    const sliceValue = event.points[0].value; // Get the value of the clicked slice
    const slicePercent = event.points[0].percent; // Get the percent of the clicked slice
    const x = event.points[0].x; // X position of the slice
    const y = event.points[0].y; // Y position of the slice

    // Create an annotation for the clicked slice
    const newAnnotation = {
      text: labels.map(label => label == ' ' ? null : kpis.join("\n")),
      // Text to display
      x: event.points[0].x, // X coordinate of the annotation
      y: event.points[0].y, // Y coordinate of the annotation
      xref: "paper",
      yref: "paper",
      showarrow: true, // Display an arrow pointing to the slice
      arrowhead: 7,
      ax: 0, // Arrow's x coordinate
      ay: -40, // Arrow's y coordinate (adjustable for placement)
    };

    // Update the annotations state
    setAnnotations([newAnnotation]); // Replace with the new annotation on each click
  };

  if (type === "GAUGE") {
    return (
      <div className={`text-center ${isEmptyState ? "empty-state-opacity" :""}`}>
         {/* {
          gaugeThreshhold && <div className="text-center">
            Threshold: {gaugeThreshhold} %
          </div>
        } */}
        <Plot
          data={[
            {
              type: "indicator",
              number: {
                font: {
                  size: 10  // Adjust font size of the center value
                }
              },
             
              mode: "gauge+number",
              value: gaugeValue ? Math.round(gaugeValue):"-", // value to display on the gauge
              number:  {suffix:"%"},
              gauge: {
                axis: { range: [0, 100] }, // setting the range of the gauge
                bar: { color: gaugeColor }, // color of the gauge's pointer
                steps: [
                  { range: [0, 50], color: "white" },
                  { range: [50, 100], color: "white" },

                ],
                
                threshold: {
                  line: { color: "#D41159", width: 4 },
                  thickness: 0.75,
                  value: gaugeThreshhold, // setting a threshold indicator
                },
              },
            },
          ]}
          layout={{
            width: 300,
            height: 250,
            title: title,
            ...(gaugeThreshhold && !isEmptyState ? {
              annotations: [
                {
                  x: 0.5,  // X position on the gauge (centered at 0.5)
                  y: -0.2,  // Y position, adjust as needed
                  xref: 'paper',
                  yref: 'paper',
                  text: `Benchmark: ${gaugeThreshhold} %`,  // Label text
                  showarrow: false,
                  font: {
                    size: 11,
                    color: "#f20a86"
                  }
                }
              ]
            } : isEmptyState ? {
              annotations: [
                {
                  x: 0.5,  // X position on the gauge (centered at 0.5)
                  y: -0.2,  // Y position, adjust as needed
                  xref: 'paper',
                  yref: 'paper',
                  text: `No Data`,  // Label text
                  showarrow: false,
                  font: {
                    size: 15,
                    color: "black"
                  }
                }
              ]
            }:"")

          }}
        />
       
      </div>
    );
  } else {
    return (
      <div>

        <Plot
          data={data}
          layout={layout}
          style={{ width: "400px", height: "400px" }}
          config={{ responsive: true }}
          onClick={handleClick}
        />




      </div>

    );
  }
};

// Define PropTypes for type checking
CurrentPiechart.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  values: PropTypes.arrayOf(PropTypes.number).isRequired,
  title: PropTypes.string,
  colors: PropTypes.arrayOf(PropTypes.string),
};

export default CurrentPiechart;
